// Voice utility functions for text-to-speech functionality

export const initializeSpeechSynthesis = () => {
  if (typeof window !== 'undefined' && !window.speechSynthesis) {
    return false;
  }
  return true;
};

export const loadVoices = () => {
  const voices = window.speechSynthesis.getVoices();
  if (voices.length === 0) {
    window.speechSynthesis.onvoiceschanged = loadVoices;
  } else {
    window.speechSynthesis.onvoiceschanged = null;
  }
  return voices;
};

export const findSuitableVoice = (voices) => {
  const femaleKeywords = [
    'female', 'woman', 'girl', 'samantha', 'zira', 'victoria',
    'karen', 'tessa', 'fiona', 'moira', 'siri', 'cortana'
  ];
  
  const maleKeywords = ['male', 'man', 'boy'];
  
  const femaleVoice = voices.find((voice) => {
    const name = voice.name.toLowerCase();
    const isFemale = femaleKeywords.some(keyword => name.includes(keyword));
    const isNotMale = !maleKeywords.some(keyword => name.includes(keyword));
    return isFemale && isNotMale;
  });

  if (femaleVoice) {
    return femaleVoice;
  }

  // If no female voice is found, try to find a voice with higher pitch
  const highPitchVoice = voices.find(
    (voice) => voice.name.toLowerCase().includes('high') || voice.name.toLowerCase().includes('soprano')
  );
  
  if (highPitchVoice) {
    return highPitchVoice;
  }
  
  // If still no suitable voice found, use the first available voice
  return voices.length > 0 ? voices[0] : null;
};

export const speakText = (text, startPosition = 0, callbacks = {}) => {
  try {
    if (!window.speechSynthesis) {
      console.error('Speech synthesis not supported');
      return;
    }

    const voices = window.speechSynthesis.getVoices();
    if (voices.length === 0) {
      window.speechSynthesis.onvoiceschanged = () => {
        window.speechSynthesis.onvoiceschanged = null;
        speakText(text, startPosition, callbacks);
      };
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 0.9;
    utterance.pitch = 1.0;
    utterance.volume = 1.0;

    const suitableVoice = findSuitableVoice(voices);
    if (suitableVoice) {
      utterance.voice = suitableVoice;
    } else {
      console.warn('No suitable voice found');
    }

    // Set up event handlers
    if (callbacks.onBoundary) {
      utterance.onboundary = callbacks.onBoundary;
    }
    if (callbacks.onEnd) {
      utterance.onend = callbacks.onEnd;
    }
    if (callbacks.onError) {
      utterance.onerror = callbacks.onError;
    }

    // If resuming from a position, skip to that point
    if (startPosition > 0) {
      utterance.text = text.substring(startPosition);
    }

    window.speechSynthesis.speak(utterance);
  } catch (error) {
    console.error('Error in speech synthesis:', error);
    if (callbacks.onError) {
      callbacks.onError(error);
    }
  }
};

export const stopSpeech = () => {
  if (window.speechSynthesis) {
    window.speechSynthesis.cancel();
  }
}; 